import { Controller } from '@hotwired/stimulus';

import Checkout from '@/modules/checkout';
import Coupon from '@/modules/coupon';
import ModuleLoader from '@/modules/module_loader';

export default class extends Controller {
  connect() {
    new Checkout(ModuleLoader.getOptions()).create();
    new Coupon({ namespace: 'subscription' }).init();
  }
}
